export default __webpack_public_path__ + "static/media/KAVIAR_2.bfb605f5.gif";